import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { ScheduledDifferentialRateDto } from './facility-billable-rate.dto';

export interface ScopeDifferentialRateDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  differentialRate: number;
  scheduledDifferentialRates: ScheduledDifferentialRateDto[];
}
